import { render, staticRenderFns } from "./SushiDiaoxianA3.vue?vue&type=template&id=974ab3c2&scoped=true&"
import script from "./SushiDiaoxianA3.vue?vue&type=script&lang=js&"
export * from "./SushiDiaoxianA3.vue?vue&type=script&lang=js&"
import style0 from "./SushiDiaoxianA3.vue?vue&type=style&index=0&id=974ab3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974ab3c2",
  null
  
)

export default component.exports